import React, { useState, useEffect } from "react";
import TabsContainer from "../../../../components/Common/TabsContainer";
import SchoolGeneralInfo from "../GeneralInfo";
import ButtonInput from "../../../../components/Common/ButtonInput";
import * as BootstrapVariants from "../../../../constants/Bootstrap/Variants";
import DataGrid from "../../../Common/DataGrid";
import {
  getSchool,
  searchSchoolColleges,
  searchClazzs,
  searchDomains,
  searchUsers,
} from "../../../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import * as DataTypes from "../../../../constants/Data/DataTypes";
import * as QueryTypes from "../../../../graphql/Constants/QueryTypes";
import { toast } from "react-toastify";
import PagePreLoad from "../../../../components/Common/PagePreLoad";
import CollegeNONE from "../../../../graphql/Constants/Colleges/None";
import CardContainer from "../../../../components/Common/CardContainer";

const SchoolDetails = (props) => {
  const [schoolName, setSchoolName] = useState("");
  const [schoolCollegesTotalCount, setSchoolCollegesTotalCount] = useState(
    null
  );
  const [schoolDomainsTotalCount, setSchoolDomainsTotalCount] = useState(0);
  const [schoolClassesTotalCount, setSchoolClassesTotalCount] = useState(0);
  const [schoolUsersTotalCount, setSchoolUsersTotalCount] = useState(0);
  const [schoolAllUsersTotalCount, setSchoolAllUsersTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [tabsActiveTab, setTabsActiveTab] = useState(
    props.match.params.tabName
  );

  useEffect(() => {
    getSchoolData();
  }, []);

  const getSchoolData = async () => {
    try {
      const result = await API.graphql(
        graphqlOperation(getSchool, { id: props.match.params.schoolId })
      );
      const {
        name,
        numberOfColleges,
        numberOfDomains,
        numberOfClazzes,
        numberOfUsers,
        totalSchoolUsersCount,
      } = result.data.getSchool;
      // reuse the same function being called by college data grid to assign the header schoolname
      setSchoolName(name);
      setSchoolDomainsTotalCount(numberOfDomains);
      setSchoolClassesTotalCount(numberOfClazzes);
      setSchoolUsersTotalCount(numberOfUsers);
      setSchoolAllUsersTotalCount(totalSchoolUsersCount);
      setSchoolCollegesTotalCount(numberOfColleges);
    } catch (error) {
      toast.error(`Error while fetching school data ${JSON.stringify(error)}`);
    }
  };

  // make sure we load the page after the state for counts are updated
  useEffect(() => {
    if (schoolCollegesTotalCount != null) {
      setIsLoading(false);
    }
  }, [schoolCollegesTotalCount]);

  const getSchoolCollegesTotalCount = async () => {
    return schoolCollegesTotalCount;
  };

  const getSchoolDomainsTotalCount = async () => {
    return schoolDomainsTotalCount;
  };

  const getSchoolClassesTotalCount = async () => {
    return schoolClassesTotalCount;
  };

  const getSchoolUsersTotalCount = async () => {
    return schoolUsersTotalCount;
  };

  const getSchoolAllUsersTotalCount = async () => {
    return schoolAllUsersTotalCount;
  };

  const handleReturn = () => {
    props.history.push("/schools");
  };

  const handleBatchClassCreation = () => {
    props.history.push(
      `/schools/${props.match.params.schoolId}/classes/batchCreate`
    );
  };

  const handleBatchDomainCreation = () => {
    props.history.push(
      `/schools/${props.match.params.schoolId}/domains/batchCreate`
    );
  };

  const handleBatchCollegeCreation = () => {
    props.history.push(
      `/schools/${props.match.params.schoolId}/colleges/batchCreate`
    );
  };

  return (
    <PagePreLoad isLoading={isLoading}>
      <TabsContainer
        header={`School Details : ${schoolName}`}
        defaultActiveKey={tabsActiveTab}
        backButton={
          <ButtonInput
            label="Back to List"
            type="button"
            variant={BootstrapVariants.OutlineSecondary}
            onClick={() => handleReturn()}
          />
        }
        tabs={[
          {
            name: "General Info",
            eventKey: "GeneralInfo",
            content: (
              <SchoolGeneralInfo schoolId={props.match.params.schoolId} />
            ),
          },
          {
            name: "Domains",
            eventKey: "Domains",
            content: (
              <>
                <CardContainer
                  header="Batch Creation"
                  text="Create batch of domains by excel file upload."
                  submitButton={
                    <ButtonInput
                      label="Batch Creation"
                      type="button"
                      variant={BootstrapVariants.Info}
                      onClick={() => handleBatchDomainCreation()}
                    />
                  }
                />
                <DataGrid
                  header="Domains"
                  {...props}
                  gridObjectDataModel={[
                    {
                      name: "name",
                      headerText: "Name",
                      type: DataTypes.String,
                    },
                    {
                      name: "createdAt",
                      headerText: "Created At",
                      type: DataTypes.DateTime,
                    },
                  ]}
                  customTotalCountFunction={getSchoolDomainsTotalCount}
                  queryFunction={searchDomains}
                  queryFunctionType={QueryTypes.Search}
                  queryName={"searchDomains"}
                  queryFilters={{
                    schoolId: {
                      eq: props.match.params.schoolId,
                    },
                    domainCollegeId: {
                      eq: CollegeNONE.id,
                    },
                  }}
                  hasCreate={true}
                  hasDetails={true}
                  hasEdit={true}
                  hasDelete={true}
                  baseRoute={`schools/${props.match.params.schoolId}/domains`}
                />
              </>
            ),
          },
          {
            name: "Classes",
            eventKey: "Classes",
            content: (
              <>
                <CardContainer
                  header="Batch Creation"
                  text="Create batch of classes by excel file upload."
                  submitButton={
                    <ButtonInput
                      label="Batch Creation"
                      type="button"
                      variant={BootstrapVariants.Info}
                      onClick={() => handleBatchClassCreation()}
                    />
                  }
                />
                <DataGrid
                  header="Classes"
                  {...props}
                  gridObjectDataModel={[
                    {
                      name: "name",
                      headerText: "Name",
                      type: DataTypes.String,
                    },
                    {
                      name: "order",
                      headerText: "Order",
                      type: DataTypes.Number,
                    },
                    {
                      name: "createdAt",
                      headerText: "Created At",
                      type: DataTypes.DateTime,
                    },
                  ]}
                  customTotalCountFunction={getSchoolClassesTotalCount}
                  queryFunction={searchClazzs}
                  queryFunctionType={QueryTypes.Search}
                  queryName={"searchClazzs"}
                  queryFilters={{
                    schoolId: {
                      eq: props.match.params.schoolId,
                    },
                    clazzCollegeId: {
                      exists: false,
                    },
                  }}
                  hasCreate={true}
                  hasDetails={true}
                  hasEdit={true}
                  hasDelete={true}
                  baseRoute={`schools/${props.match.params.schoolId}/classes`}
                />
              </>
            ),
          },
          {
            name: "Colleges",
            eventKey: "Colleges",
            content: (
              <>
                <CardContainer
                  header="Batch Creation"
                  text="Create batch of colleges by excel file upload."
                  submitButton={
                    <ButtonInput
                      label="Batch Creation"
                      type="button"
                      variant={BootstrapVariants.Info}
                      onClick={() => handleBatchCollegeCreation()}
                    />
                  }
                />
                <DataGrid
                  header="Colleges"
                  {...props}
                  gridObjectDataModel={[
                    {
                      name: "name",
                      headerText: "Name",
                      type: DataTypes.String,
                    },
                    {
                      name: "createdAt",
                      headerText: "Created At",
                      type: DataTypes.DateTime,
                    },
                  ]}
                  customTotalCountFunction={getSchoolCollegesTotalCount}
                  queryFunction={searchSchoolColleges}
                  queryFunctionType={QueryTypes.Search}
                  queryName={"searchSchoolColleges"}
                  queryFilters={{
                    schoolId: {
                      eq: props.match.params.schoolId,
                    },
                  }}
                  hasCreate={true}
                  hasDetails={true}
                  detailsActiveTab="GeneralInfo"
                  hasEdit={true}
                  hasDelete={true}
                  baseRoute={`schools/${props.match.params.schoolId}/colleges`}
                />
              </>
            ),
          },
          {
            name: "Users",
            eventKey: "Users",
            content: (
              <DataGrid
                header="Users"
                {...props}
                gridObjectDataModel={[
                  {
                    name: "userName",
                    headerText: "UserName",
                    type: DataTypes.String,
                  },
                  {
                    name: "firstName",
                    headerText: "First Name",
                    type: DataTypes.String,
                  },
                  {
                    name: "lastName",
                    headerText: "Last Name",
                    type: DataTypes.String,
                  },
                  {
                    name: "isBlocked",
                    headerText: "Is Blocked",
                    type: DataTypes.Boolean,
                  },
                  {
                    name: "isProfane",
                    headerText: "Is Marked as Profane",
                    type: DataTypes.Boolean,
                  },
                  {
                    name: "numberOfTimesReferralCodeUsed",
                    headerText: "Number of Referred Users",
                    type: DataTypes.Boolean,
                  },
                  {
                    name: "createdAt",
                    headerText: "Created At",
                    type: DataTypes.DateTime,
                  },
                ]}
                customTotalCountFunction={getSchoolUsersTotalCount}
                queryFunction={searchUsers}
                queryFunctionType={QueryTypes.Search}
                queryName={"searchUsers"}
                queryFilters={{
                  schoolId: {
                    eq: props.match.params.schoolId,
                  },
                  userCollegeId: {
                    eq: CollegeNONE.id,
                  },
                }}
                hasCreate={false}
                hasDetails={true}
                hasEdit={false}
                hasDelete={true}
                hasBlock={true}
                hasProfane={true}
                baseRoute={`schools/${props.match.params.schoolId}/users`}
                detailsActiveTab={"Users"}
              />
            ),
          },
          {
            name: "All School Users",
            eventKey: "AllUsers",
            content: (
              <DataGrid
                header="All School Users"
                {...props}
                gridObjectDataModel={[
                  {
                    name: "userName",
                    headerText: "UserName",
                    type: DataTypes.String,
                  },
                  {
                    name: "firstName",
                    headerText: "First Name",
                    type: DataTypes.String,
                  },
                  {
                    name: "lastName",
                    headerText: "Last Name",
                    type: DataTypes.String,
                  },
                  {
                    name: "isBlocked",
                    headerText: "Is Blocked",
                    type: DataTypes.Boolean,
                  },
                  {
                    name: "isProfane",
                    headerText: "Is Marked as Profane",
                    type: DataTypes.Boolean,
                  },
                  {
                    name: "numberOfTimesReferralCodeUsed",
                    headerText: "Number of Referred Users",
                    type: DataTypes.Boolean,
                  },
                  {
                    name: "createdAt",
                    headerText: "Created At",
                    type: DataTypes.DateTime,
                  },
                ]}
                customTotalCountFunction={getSchoolAllUsersTotalCount}
                queryFunction={searchUsers}
                queryFunctionType={QueryTypes.Search}
                queryName={"searchUsers"}
                queryFilters={{
                  schoolId: {
                    eq: props.match.params.schoolId,
                  },
                }}
                hasCreate={false}
                hasDetails={true}
                hasEdit={false}
                hasDelete={true}
                hasBlock={true}
                hasProfane={true}
                baseRoute={`schools/${props.match.params.schoolId}/users`}
                detailsActiveTab={"AllUsers"}
              />
            ),
          },
        ]}
      />
    </PagePreLoad>
  );
};

export default SchoolDetails;
